import { isImageDocument } from './media';

type DocumentLike = {
  fileName?: string | null;
  url?: string | null;
  isPrimary: boolean;
  isDeleted: boolean;
};

function pickFromDocs(docs: DocumentLike[] | undefined): string | null {
  if (!docs?.length) return null;
  const nonDeleted = docs.filter((d) => !d.isDeleted && isImageDocument(d));
  if (!nonDeleted.length) return null;
  const primary = nonDeleted.find((d) => d.isPrimary);
  const chosen = primary ?? nonDeleted[0];
  return chosen?.url ?? null;
}

/**
 * Picks the display image URL for lot-animal rows.
 * 1. Prefer documents: non-deleted only; use isPrimary if set, else first. Return url if any.
 * 2. Fallback to animalDocuments: same logic.
 * 3. Otherwise return null (no image).
 */
export function pickPrimaryImageUrl(
  documents?: DocumentLike[],
  animalDocuments?: DocumentLike[],
): string | null {
  const fromDocs = pickFromDocs(documents);
  if (fromDocs) return fromDocs;
  return pickFromDocs(animalDocuments);
}
